import React, { useState } from 'react';
import { useSelector ,useDispatch} from 'react-redux';
import { Form, Col, Container, Row, Button, Alert, OverlayTrigger, Popover, Tooltip } from 'react-bootstrap';
import {
  Redirect,
  Link
} from "react-router-dom";
import Card from 'react-bootstrap/Card';
import { selectUser } from '../auth/authSlice';
import { searchExternalUser, resetUIMessage, selectUserFound, selectExternalUsersFound, selectShowAlert, selectExternalUserAllocated, listExternalUserAllocated} from './userManagementSlice';
import { requestAffiliation } from '../useraffiliation/userAffiliationSlice';
import Table from 'react-bootstrap/Table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { listExternalUserTasks, unlistExternalUserTasks} from "../externalsurveyallocation/externalUserTasksSlice";
import { listExternalSignUpRequests, selectExternalSignUpRequests, archiveExternalSignUpRequest } from '../externalsignuprequests/externalSignUpRequestsSlice';

export function ExternalUserManagement() {

  const user = useSelector(selectUser);
  const success = useSelector(selectUserFound)
  const showUserNotFoundAlert = useSelector(selectShowAlert)
  const [emailState, setEmailState] = useState('');
  const externaluserlist = useSelector(selectExternalUserAllocated);
  const externalusersfound = useSelector(selectExternalUsersFound);
  const externalsignuprequests = useSelector(selectExternalSignUpRequests);
  const [pointerState, setPointerState] = useState('auto');
  const [isEmailValid, setIsEmailValid] = useState(true); 
  const [error, setError] = useState('');

  const dispatch = useDispatch();

  const getEmail = (e) => {
    const emailValue = e.target.value;
    setEmailState(emailValue);
    const emailValidresponse = validateEmail(emailValue)
    setIsEmailValid(emailValidresponse.isValid);
    setError(emailValidresponse.error);
  };

  const validateEmail = (email) => {
    // Rule 1: The email should not begin or end with a dot.
    if (email.startsWith('.') || email.endsWith('.')) {
      return { isValid: false, error: "Email should not start or end with a dot." };
    }
  
    // Rule 2: The domain part and local part must be there
    const [localPart, domainPart] = email.split('@');
    if (!localPart || !domainPart) {
      return { isValid: false, error: "Email must contain a local and domain part separated by '@'." };
    }
  
    // Rule 3: A dot should not immediately follow the '@' symbol.
    if (domainPart.startsWith('.') || domainPart.endsWith('.')) {
      return { isValid: false, error: "The domain part should not start with a dot after '@'." };
    }
  
    // Rule 4: Consecutive dots (..) are not allowed in the local part.
    if (localPart.includes('..')) {
      return { isValid: false, error: "The local part should not contain consecutive dots (..)." };
    }

    // Rule 5: . not allowed in the end of local part.
    if (localPart.endsWith('.')) {
      return { isValid: false, error: "The local part should not end with a dot." };
    }

    // const domainLevels = domainPart.split(".");
    // if (domainLevels.length > 3) {
    //   return { isValid: false, error: "The domain part must have one or two subdomain levels (e.g., 'example.com or example.com.ie')." };
    // }
    
    // Rule 6: Standard check.
    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~áéíóúàèìòùċḋṁṡṫ-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/;
    if (!emailRegex.test(email)) {
      return { isValid: false, error: "Please enter valid email format." };
    }
  
    // If all checks pass
    return { isValid: true, error: null };
  };

  function dateFormat(longDate) {
    if (longDate && longDate !== "" && longDate !== " ") {
      const unixStamp = Date.parse(longDate);
      const newDate = new Date(unixStamp)
      //const readableDate = newDate
      const dateString = newDate.getDate().toString() +
        "/" + (newDate.getMonth() + 1).toString() +
        "/" + newDate.getFullYear().toString()

      return dateString;
    }
    else return null;
  }

  React.useEffect(() => {
    dispatch(resetUIMessage())
    dispatch(unlistExternalUserTasks())
    dispatch(listExternalUserAllocated())
    dispatch(listExternalSignUpRequests())
  }, [dispatch]);

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  function resetPointer(){
    sleep(2000).then(() => { setPointerState('auto') });
  }

  const userType = user.groups && user.groups.toString();
  let admin;
  if(typeof userType !== "undefined")
  {
    const strIndex = userType.indexOf('ADMINS');
    if(strIndex === -1) {
      admin = false;
    } else {
      admin = true;
    }
  } 

  if(admin){
    return (
      <div style={{padding:"3rem 2rem 0 2rem"}}>
        <Row>
          <Col>
            <Container>
              <Card>
                <Card.Header style={{backgroundColor: "#1D345C", color: "white"}}>
                  <h3 style={{textAlign:'left', float:'left'}}>Search External Users</h3>
                  <OverlayTrigger
                      placement="top"
                      delay={{ show: 150, hide: 300 }}
                      overlay={(
                      <Popover id="popover-basic">
                          <Popover.Body>
                              An external user is a user not belonging to your organisation that you can grant file upload access to.
                              Use this form to search for registered external users via email address.
                          </Popover.Body>
                      </Popover>
                      )} >
                      <h5 style={{textAlign:'right', float:'right'}}><FontAwesomeIcon icon={faInfoCircle}/></h5>
                  </OverlayTrigger>
                </Card.Header>
                <Card.Body>
                <Form>
                    <Form.Group as={Row} controlId="userEmail">
                      <Form.Label column sm="8">
                        Email Address
                      </Form.Label>
                      <Col sm="10">
                        <Form.Control 
                          disabled= {success || showUserNotFoundAlert}
                          type="text" 
                          onChange={getEmail}
                          value={emailState}
                          isInvalid={!isEmailValid && emailState !== ''}
                        />
                        <Form.Control.Feedback type="invalid">
                          {error}
                        </Form.Control.Feedback>
                      </Col>
                    </Form.Group>
                    <div style={{float: "right"}} className="pt-2 pr-3">
                        <OverlayTrigger
                          delay={{ hide: 450, show: 300 }}
                          overlay={(props) => (
                            <Tooltip {...props}>
                              Please provide an email address to complete the registration of an external user.
                            </Tooltip>
                          )}
                          placement="bottom"
                        >
                        <Button 
                          disabled={!isEmailValid || emailState === ""} 
                          onClick={() => {
                            dispatch(searchExternalUser(emailState.trim()));
                            }}
                          variant="info">Search for External User</Button>
                        </OverlayTrigger>
                    </div>
                    <div>
                      <Alert show={success} variant="success">
                        <Alert.Heading>Found!</Alert.Heading>
                          <p>
                            At least one external user is registered with this email address.
                            <br></br>
                            <b>{emailState}</b>
                            <br></br>
                            <br></br>
                            <Table responsive striped bordered hover size="sm" variant="light">
                            <thead>
                              <tr>
                                <td><b>Username</b></td>
                                <td><b>Email</b></td>
                                <td><b>Name</b></td>
                                <td><b>Company</b></td>
                                <td><b>Affiliate</b></td>
                              </tr>
                            </thead>
                            <tbody>
                              {externalusersfound.map((userRow, key) => {
                                return (
                                  <tr key={key}>
                                    <td>{userRow.username}</td>
                                    <td>{userRow.email}</td>
                                    <td>{userRow.name}</td>
                                    <td>{userRow.company}</td>
                                    <td>
                                      <div style={{ textAlign: "center" }}>
                                        <Button onClick={() => {
                                          dispatch(requestAffiliation(userRow.username))
                                          dispatch(resetUIMessage())
                                          setEmailState('')
                                          }}
                                          variant="success">
                                          Request
                                        </Button>
                                      </div>
                                    </td>
                                  </tr>
                                  )
                              })}
                            </tbody>
                            </Table>
                            Click on "Request" to send an affiliation request to a user.
                            <br></br>This will not grant them any explicit permissions but will allow tasks to be assigned them if they accept.
                            <br></br>Your contact details will be included in the request.
                          </p>
                          <div className="pt-2 pr-3">
                            <Button onClick={() => {
                                dispatch(resetUIMessage())
                                setEmailState('')
                                }}
                                variant="danger">
                                Reset Form
                            </Button>
                          </div>
                      </Alert>
                      <Alert show={showUserNotFoundAlert} variant="info">
                        <Alert.Heading>External user not found</Alert.Heading>
                          <p>
                            No external user is registered with this email address.
                            <br></br>
                            <b>{emailState}</b>
                            <br></br>
                            <br></br>
                            Click on "Request Sign-Up" to send a sign-up request to this email.
                            <br></br>Your contact details will be included in the request and you must include a message.
                          </p>
                            <div>
                              <Link to={{ pathname: "/home/contact/external", state: { email: emailState } }}>
                                <Button onClick={() => {
                                  dispatch(resetUIMessage())
                                  setEmailState('')
                                  }}
                                  variant="info">
                                  Request Sign-Up
                                </Button>
                              </Link>
                            </div>
                            <div className="pt-2 pr-3">
                              <Button onClick={() => {
                                  dispatch(resetUIMessage())
                                  setEmailState('')
                                  }}
                                  variant="danger">
                                  Reset Form
                              </Button>
                            </div>
                      </Alert>
                    </div>
                </Form>
                </Card.Body>
              </Card>
            </Container>
              </Col>
            <Col>
            <Container className="user-action">
                <Card>
                  <Card.Header style={{backgroundColor: "#1D345C", color: "white"}}>
                    <h3 style={{textAlign:'left', float:'left'}}>Affiliated External Users</h3>
                    <h5 style={{textAlign:'right', float:'right'}}><FontAwesomeIcon style={{cursor: 'pointer', pointerEvents: pointerState }} 
                      onClick={() => {
                        setPointerState('none')
                        dispatch(listExternalUserAllocated())
                        dispatch(listExternalSignUpRequests())
                        resetPointer()
                        }}
                      icon={faSync}/></h5>
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 150, hide: 300 }}
                      overlay={(
                      <Popover id="popover-basic">
                          <Popover.Body>
                              These are users that have been sent an affiliation request by your organisation. Users with an ACTIVE status have accepted the request, while users with a PENDING status have yet to respond.
                          </Popover.Body>
                      </Popover>
                      )} >
                      <h5 style={{textAlign:'right', float:'right'}}><FontAwesomeIcon icon={faInfoCircle}/> &nbsp; &nbsp; </h5>
                  </OverlayTrigger>
                  </Card.Header>
                {externaluserlist ?
                  <Card.Body>
                  <Table responsive striped bordered hover size="sm">
                    <thead>
                      <tr>
                        <td><b>Username</b></td>
                        <td><b>Email</b></td>
                        <td><b>Status</b></td>
                        <td><b>User Actions</b></td>
                      </tr>
                    </thead>
                    {externaluserlist.length > 0 ? (
                      <tbody>
                        {externaluserlist.map((userRow, key) => {
                          return (
                            <tr key={key}>
                              {console.log(userRow)}
                              <td>{userRow.Username}</td>
                              <td>{userRow.email}</td>
                              <td>{userRow.Status}</td>
                              <td>
                              {userRow.Status === "ACTIVE" ? (
                                  <Link to={{ pathname: "/home/allocate/external", state: { username: userRow.Username } }}>
                                    <div style={{ textAlign: "center" }}>
                                      <Button
                                        onClick={() => dispatch(listExternalUserTasks(userRow.Username, user.cso_identifier))}
                                        variant="info"
                                      >
                                        User Actions
                                      </Button>
                                    </div>
                                  </Link>
                                ) : (
                                  <div style={{ textAlign: "center" }}>
                                    <Button variant="info" disabled>
                                      User Actions
                                    </Button>
                                  </div>
                                )}
                              </td>
                            </tr>
                            )
                        })}
                      </tbody>
                    ) : (
                      <tbody>
                        <div>You currently have no affiliated external users.</div>
                      </tbody>
                    )}
                </Table>
                  </Card.Body> : <Card.Body>
                    Loading...
                  </Card.Body>}

                </Card>
            </Container>
            <Container className="emails-sent pt-5">
                <Card>
                  <Card.Header style={{backgroundColor: "#1D345C", color: "white"}}>
                    <h3 style={{textAlign:'left', float:'left'}}>Sign-Up Requests Sent</h3>
                    <h5 style={{textAlign:'right', float:'right'}}><FontAwesomeIcon style={{cursor: 'pointer', pointerEvents: pointerState }} 
                      onClick={() => {
                        setPointerState('none')
                        dispatch(listExternalSignUpRequests())
                        dispatch(listExternalUserAllocated())
                        resetPointer()
                        }}
                      icon={faSync}/> </h5>
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 150, hide: 300 }}
                      overlay={(
                      <Popover id="popover-basic">
                          <Popover.Body>
                              These are users that have not been sent an affiliation request by your organisation but have been sent sign-up instructions via email.
                          </Popover.Body>
                      </Popover>
                      )} >
                      <h5 style={{textAlign:'right', float:'right'}}><FontAwesomeIcon icon={faInfoCircle}/> &nbsp; &nbsp; </h5>
                  </OverlayTrigger>
                  </Card.Header>
                  {externalsignuprequests ?
                  <Card.Body>
                  <Table responsive striped bordered hover size="sm">
                    <thead>
                      <tr>
                        <td><b>Email</b></td>
                        <td><b>Username</b></td>
                        <td><b>Requested By</b></td>
                        <td><b>Date Requested</b></td>
                        <td><b>Status</b></td>
                        <td>
                          <OverlayTrigger
                            placement="top"
                            delay={{ show: 150, hide: 300 }}
                            overlay={(
                              <Popover id="popover-basic">
                                <Popover.Body>
                                  Send an affiliation request to this user.
                                  This will not grant them any explicit permissions but will allow tasks to be assigned them if they accept.
                                  Your contact details will be included in the request.
                                  Only users with a status of REGISTERED can be sent an afffiliation request.
                                </Popover.Body>
                              </Popover>
                            )} >
                            <div>
                              <b>Affiliate</b> <FontAwesomeIcon icon={faInfoCircle} />
                            </div>
                          </OverlayTrigger>
                        </td>
                        <td>
                          <OverlayTrigger
                            placement="top"
                            delay={{ show: 150, hide: 300 }}
                            overlay={(
                              <Popover id="popover-basic">
                                <Popover.Body>
                                  Archiving a record from this table just hides the row from being displayed, this does not send any further communication to the user.
                                </Popover.Body>
                              </Popover>
                            )} >
                            <div>
                              <b>Archive</b> <FontAwesomeIcon icon={faInfoCircle} />
                            </div>
                          </OverlayTrigger>
                        </td>
                      </tr>
                    </thead>
                    {externalsignuprequests.length > 0 ? (
                      <tbody>
                        {externalsignuprequests.map((userRow, key) => {
                          return (
                            <tr key={key}>
                              <td>{userRow.PK.split('USERREGISTER#')[1]}</td>
                              <td>{userRow.Username}</td>
                              <td>{userRow.Requestor}</td>
                              <td>{dateFormat(userRow.Date)}</td>
                              <td>{userRow.Status}</td>
                              <td>
                                <div style={{ textAlign: "center" }} >
                                  <Button onClick={() => {
                                      dispatch(requestAffiliation(userRow.Username))
                                    }}
                                    disabled = {!userRow.Username && userRow.Status !== "REGISTERED"}
                                    variant="info">
                                    Request
                                  </Button>
                                </div>
                              </td>
                              <td>
                                <div style={{ textAlign: "center" }} >
                                  <Button onClick={() => {
                                      dispatch(archiveExternalSignUpRequest(userRow.PK.split('USERREGISTER#')[1]))
                                    }}
                                    variant="warning">
                                    Archive
                                  </Button>
                                </div>
                              </td>
                            </tr>
                            )
                        })}
                      </tbody>
                    ) : (
                      <tbody>
                        <div>You currently have no outstanding sign up requests.</div>
                      </tbody>
                    )}
                </Table>
                  </Card.Body> : <Card.Body> Loading... </Card.Body>}
                </Card>
            </Container>
          </Col>
        </Row>
      </div>
    );
  }
  else {
    return(
    <Redirect to="/homepage"/>
    )
  }
}
